import { combineReducers } from "@reduxjs/toolkit";
import { authReducer } from "./auth";

export type RootState = ReturnType<typeof rootReducer>;

export const rootReducer = combineReducers({
  auth: authReducer,
});
